import { useState, useEffect } from "react";
import AppLayout from "@amzn/awsui-components-react/polaris/app-layout";
import PageHeader from "../PageHeader";
import DlqRedriveContent from "./DlqRedriveContent";
import { StageContext } from "../../contexes/OrderIdContext";
import { Stage } from "../../lusca-search-api/generated-src";
import { DEFAULT_STAGE } from "../../constants";
export default function DlqRedrive() {
  const [stage, setStage] = useState(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return (urlParams.get("stage") as Stage) || DEFAULT_STAGE;
  });

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set("stage", stage);
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${urlParams.toString()}`
    );
  }, [stage]);

  return (
    <StageContext.Provider value={stage}>
      <PageHeader />
      <AppLayout
        content={<DlqRedriveContent setStage={setStage} />}
        contentType="default"
        headerSelector="#h"
        maxContentWidth={1700}
        navigationHide
        toolsHide
      />
    </StageContext.Provider>
  );
}
